// slices/requestSlice.js
import { createSlice } from "@reduxjs/toolkit"

const appRequestSlice = createSlice({
  name: "request",
  initialState: {
    requestedApps: [],
  },
  reducers: {
    setRequestedApps: (state, action) => {
      state.requestedApps = action.payload
    },
    addRequestedApp: (state, action) => {
      state.requestedApps.push(action.payload)
    },
    removeApp: (state, action) => {
      state.requestedApps.filter((item) => item != action.payload)
    },
  },
})

export const { setRequestedApps, addRequestedApp, removeApp } =
  appRequestSlice.actions
export default appRequestSlice.reducer
